import { AnimatePresence, motion } from 'motion/react';
import { BaleProcessedContextProvider, BaleProcessedPageType } from './context';
import { useBaleProcessedContext } from './hook';
import { BaleProcessedFooter } from './processed-footer';
import { BaleProcessedConfirmationPage } from './subroutes/processed-confirmation';
import { BaleProcessedScanPage } from './subroutes/processed-scan';

export const FacilityBaleProcessedPage = () => {
	return (
		<BaleProcessedContextProvider>
			<BaleProcessedPageRoot />
		</BaleProcessedContextProvider>
	);
};

const BaleProcessedPageRoot = () => {
	return (
		<AnimatePresence>
			<SubRoute id="SCAN" component={<BaleProcessedScanPage />} />
			<SubRoute id="CONFIRM" component={<BaleProcessedConfirmationPage />} />
			<BaleProcessedFooter />
		</AnimatePresence>
	);
};

const SubRoute = ({ id, component }: { id: BaleProcessedPageType; component: React.ReactNode }) => {
	const { page } = useBaleProcessedContext();

	if (page !== id) return null;

	return (
		<motion.div
			key={id}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
		>
			{component}
		</motion.div>
	);
};
